const actionTypes = {
  GET_RFP_BY_USER_START: "GET_RFP_BY_USER_START",
  GET_RFP_BY_USER_SUCCESS: "GET_RFP_BY_USER_SUCCESS",
  GET_RFP_BY_USER_FAILED: "GET_RFP_BY_USER_FAILED",

}

export default actionTypes;